import React from 'react';

export const ResultContext = React.createContext({
  currentResult: 50,
  setCurrentResult: (value: number) => {},
});
